import gql from 'graphql-tag';

const Constants = {
  GroupDescriptionMaxChars: 200,
  GroupPriceMax: 10000,
  GroupPriceMin: 0,
  GroupThumbnailWidth: 200,
  GroupThumbnailHeight: 120,
  GroupCardDefaultBackgroundColor: {
    ADMIN: '#9ec751',
    REVIEWER: '#9ec751',
    MEMBER: '#777'
  },
  GraphQL: {
    Query: {
      // TODO: We probably want to refetch this GET_NUMBER_OF_GROUP_MEMBERS when
      // members are added at membership mutation ADD_GROUP_MEMBER_BY_EMAIL. The
      // mutation is on the MEMBERSHIP_GQL ApolloClient, whereas the query here
      // on the GROUP_GQL client. See also refetch on _deleteGroupMember in
      // useMemberships.ts and refetch of GET_NUMBER_OF_GROUP_COURSES.
      GET_NUMBER_OF_GROUP_MEMBERS: gql`
        query GetNumberOfGroupMembers($groupkey: Int!) {
          getNumberOfGroupMembers(groupkey: $groupkey)
        }
      `,
      GET_NUMBER_OF_GROUP_COURSES: gql`
        query GetNumberOfGroupCourses($groupkey: Int!) {
          getNumberOfGroupCourses(groupkey: $groupkey)
        }
      `,
      LIST_USER_GROUP_RELATIONS: gql`
        query listUserGroupRelations($userkey: Int!) {
          listUserGroupRelations(userkey: $userkey) {
            groupkey
            title
            autojoin
            nodelete
            public
            master
            parents
            children
            access {
              rights
              list
              member
              content
              report
              assess
              discuss
            }
            role
            assets {
              amount
              description
              media
              code
            }
          }
        }
      `,
      LIST_USER_GROUPS_BY_ACCESS: gql`
        query listUserGroupsByAccess($access: Int!) {
          listUserGroupsByAccess(access: $access) {
            groupkey
            title
          }
        }
      `,
      LIST_USER_GROUP_MEMBERS: gql`
        query listUserGroupMembers($groupkey: Int!) {
          listUserGroupMembers(groupkey: $groupkey) {
            groupkey
            userkey
            username
            created
            role
            access
            title
            permissions {
              rights
              list
              member
              content
              report
              assess
              discuss
            }
            firstname
            lastname
            selectable
            selected
            added
          }
        }
      `,
      COUNT_CLUSTER_GROUP_MEMBERS: gql`
        query countClusterGroupMembers($clusterkeys: [Int]!) {
          countClusterGroupMembers(clusterkeys: $clusterkeys) {
            groupkey
            members
            courses
          }
        }
      `,
      LIST_CANDIDATE_CHILD_GROUP_OPTIONS: gql`
        query ListCandidateChildGroupOptions($groupkey: Int!, $userkey: Int!) {
          listCandidateChildGroupOptions(
            groupkey: $groupkey
            userkey: $userkey
          ) {
            groupkey
            title
          }
        }
      `,
      LIST_GROUP_CONTENT: gql`
        query ListGroupContent($groupkey: Int!) {
          listGroupContent(groupkey: $groupkey) {
            groupkey
            pathkey
            pathname
            selected
            type
          }
        }
      `,
      LIST_ALL_GROUPS_COURSES: gql`
        query ListAllGroupsCourses($groupkeys: [Int!]) {
          listAllGroupsCourses(groupkeys: $groupkeys) {
            groupkey
            pathkey
            pathname
            selected
            type
          }
        }
      `,
      LIST_GROUP_RESOURCES: gql`
        query ListGroupResources($groupkey: Int!) {
          listGroupResources(groupkey: $groupkey) {
            collectionkey
            title
            selected
          }
        }
      `,
      LIST_ALL_GROUPS_RESOURCES: gql`
        query ListAllGroupResources($groupkeys: [Int!]) {
          listAllGroupResources(groupkeys: $groupkeys) {
            collectionkey
            title
            selected
          }
        }
      `
    },
    Mutation: {
      DELETE_USER_GROUP: gql`
        mutation DeleteUserGroup($groupkey: Int!) {
          deleteUserGroup(groupkey: $groupkey)
        }
      `,
      UPDATE_USER_GROUP_MEMBERS: gql`
        mutation UpdateMembership(
          $groupkey: Int!
          $updated: [UserGroupMemberParam]!
          $deleted: [UserGroupMemberParam]!
        ) {
          updateMembership(
            groupkey: $groupkey
            updated: $updated
            deleted: $deleted
          ) {
            groupkey
            userkey
            username
            created
            access
            title
            permissions {
              rights
              list
              member
              content
              report
              assess
              discuss
            }
            role
            firstname
            lastname
            selectable
            selected
            added
          }
        }
      `,
      ADD_USER_GROUP: gql`
        mutation AddUserGroup(
          $domainkey: Int!
          $settings: UserGroupAttributes!
        ) {
          addUserGroup(domainkey: $domainkey, settings: $settings) {
            groupkey
            title
            created
          }
        }
      `,
      ADD_CHILD_USER_GROUP: gql`
        mutation AddChildUserGroup(
          $domainkey: Int!
          $settings: UserGroupAttributes!
          $parentkey: Int!
        ) {
          addChildUserGroup(
            domainkey: $domainkey
            settings: $settings
            parentkey: $parentkey
          ) {
            groupkey
            title
            role
            parents
            children
          }
        }
      `,
      UPDATE_USER_GROUP: gql`
        mutation UpdateUserGroup(
          $groupkey: Int!
          $settings: UserGroupAttributes!
        ) {
          updateUserGroup(groupkey: $groupkey, settings: $settings) {
            groupkey
            domainkey
            title
            created
            autojoin
            nodelete
            public
            master
            joined
            assets {
              amount
              description
              media
              code
            }
          }
        }
      `,
      CREATE_RELATION: gql`
        mutation CreateRelation($parentkey: Int!, $childkey: Int!) {
          createRelation(parentkey: $parentkey, childkey: $childkey) {
            parentkey
            childkey
          }
        }
      `,
      DELETE_RELATION: gql`
        mutation DeleteRelation($parentkey: Int!, $childkey: Int!) {
          deleteRelation(parentkey: $parentkey, childkey: $childkey)
        }
      `,
      UPDATE_USER_GROUP_CONTENT: gql`
        mutation UpdateGroupContent($updated: [UserGroupContentParam]!) {
          updateGroupContent(updated: $updated)
        }
      `,
      JOIN_GROUP: gql`
        mutation JoinGroup($joinGroupParams: JoinGroupParams!) {
          joinGroup(joinGroupParams: $joinGroupParams) {
            groupkey
            userkey
          }
        }
      `,
      CREATE_USER_GROUP_RESOURCE: gql`
        mutation CreateUserGroupResource(
          $groupkey: Int!
          $collectionkey: Int!
        ) {
          createUserGroupResource(
            groupkey: $groupkey
            collectionkey: $collectionkey
          ) {
            groupkey
            collectionkey
          }
        }
      `,
      DELETE_USER_GROUP_RESOURCE: gql`
        mutation DeleteUserGroupResource(
          $groupkey: Int!
          $collectionkey: Int!
        ) {
          deleteUserGroupResource(
            groupkey: $groupkey
            collectionkey: $collectionkey
          )
        }
      `
    }
  }
};

export default Constants;
